export function TestimonialsSection() {
  const testimonials = [
    {
      name: 'María González',
      role: 'Emprendedora Digital',
      text: 'Gracias a esta metodología pude vender mi primer producto en 7 días sin experiencia. Los cursos son súper prácticos y el soporte es increíble.',
      avatar: 'https://static.readdy.ai/image/c6480204573b59b5730f698dd3ee5117/6be51575f1c7badeef46088784a23d38.jpeg'
    },
    {
      name: 'Carlos Ramírez jurca',
      role: 'Consultor de Marketing',
      text: 'Los pasos son simples y aplicables, incluso si nunca has hecho publicidad. En 2 semanas ya estaba generando resultados consistentes.',
      avatar: 'https://static.readdy.ai/image/c6480204573b59b5730f698dd3ee5117/151ec6921e1ad64569daba73d305e8fa.jpeg'
    },
    {
      name: 'Ana Martínez',
      role: 'Coach Online',
      text: 'La comunidad es oro puro. Siempre hay alguien dispuesto a ayudar y los mentores responden rápido. Mejor inversión que he hecho.',
      avatar: 'https://static.readdy.ai/image/c6480204573b59b5730f698dd3ee5117/1cd5f1029f96868d169c50a484d9575e.jpeg'
    }
  ];

  return (
    <section id="testimonios" className="py-24 bg-gradient-to-br from-purple-50 via-white to-cyan-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <div className="flex items-center justify-center gap-2 text-emerald-600 font-semibold text-sm uppercase tracking-wider">
            <i className="ri-chat-quote-line text-xl"></i>
            Testimonios
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">Lo que dicen nuestros estudiantes</h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Resultados reales de personas como tú que decidieron dar el paso
          </p>
        </div>

        <div className="mb-16">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl max-w-5xl mx-auto">
            <img
              alt="Testimonios de estudiantes"
              className="w-full h-auto object-cover object-top"
              src="https://static.readdy.ai/image/c6480204573b59b5730f698dd3ee5117/903a8986b0c37e0552001f40094effd5.png"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden ring-4 ring-emerald-100 flex-shrink-0">
                  <img
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                    src={testimonial.avatar}
                  />
                </div>
                <div className="flex-1">
                  <h4 className="font-bold text-gray-900 text-lg">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.role}</p>
                </div>
              </div>

              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 border border-emerald-200 mb-4">
                <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                <span className="text-emerald-700 text-xs font-semibold whitespace-nowrap">Verificado</span>
              </div>

              <div className="relative">
                <i className="ri-double-quotes-l text-5xl text-emerald-200 absolute -top-2 -left-2"></i>
                <p className="text-gray-700 text-lg leading-relaxed relative z-10 pl-8">{testimonial.text}</p>
              </div>

              <div className="flex gap-1 mt-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
